import { baseState, baseMutations } from '@/store/mixins'
import pensionRate from '@/api/payroll/pension-rate'
export const state = {
  ...baseState
}
export const getters = {}
export const mutations = {
  ...baseMutations
}
export const actions = {
  store(context, data) {
    return pensionRate.store(data)
  },
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return pensionRate.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  update(context, { id, data }) {
    return pensionRate.update(id, data)
  },
  destroy(context, id) {
    return pensionRate.destroy(id)
  }
}
